import { createEngineClient } from '@getcircuit/engine-client'

const apiBaseUrl = 'https://api.getcircuit.com/rest/'

export const EngineClient = createEngineClient({
  baseUrl: apiBaseUrl,
})
